import React, { useState, createContext } from "react";
import Mark from "./mark";
import Domain from "./domain";
import Pays from "./pays";
import Devise from "./devise";
import Tier from "./tier";
import Tarif from "./tarif";
import License from "./license";
import UserEntity from "./user"
import Role from "./role"
import Ticket from "./ticket"
import Notification from "./notification"
import LicenceRequest from "./licenceRequest"
import BankAccount from "./bankAccount"
import ArticleFamily from "./articleFamily"
import ArticleMark from "./articleMark"
import CustomerProvenance from "./customerProvenance"
import Identity from "./identity"
import PostalCode from "./postalCode"
import StockOutType from "./stockOutType"
import ClientCurrency from "./clientCurrency";
import ClientCountry from "./clientCountry"
import ArticleClassification1 from "./articleClassification1"
import ArticleClassification2 from "./articleClassification2"
import ArticleClassification3 from "./articleClassification3"
import ArticleSubFamily from "./articleSubFamily"
import ArticleUniver from "./articleUniver"
import ArticleVariante from "./articleVariant"
import ArticleCharacteristics from "./articleCharacteristics"
import LabelText from "./labelText"
import DataCollectSection from "./dataCollectSection"
import PaymentMethod from "./paymentMethod"
import PaymentDeadline from "./paymentDeadline"
import DeliveryZone from "./deliveryZone"
import SupplierFamily from "./supplierFamily"
import DocumentComment from "./documentComment"
import CustomerFamily from "./customerFamily"
import GdrpConsent from "./gdrpConsent"
import Taxe from "./taxe"
import VatProfile from "./vatProfile"
import AccountingProfile from "./accountingProfile"
import Supplier from "./supplier"
import LoyaltyProfile from "./loyaltyProfile"
import BudgetLine from "./budgetLine"
import Dossier from "./dossier"
import Customer from "./customer"
import AdvertisingOperation from "./advertisingOperation"
import GlobalBudget from "./globalBudget"

export const FilterSortPaginationContext = createContext();

function FilterSortPaginationContextComponent(props) {
  return (
    <AdvertisingOperation>
      <GlobalBudget>
        <Customer>
          <Dossier>
            <AccountingProfile>
              <Supplier>
                <LoyaltyProfile>
                  <BudgetLine>



                    <VatProfile>
                      <Taxe>
                        <PaymentMethod>
                          <DeliveryZone>
                            <SupplierFamily>
                              <PaymentDeadline>
                                <DocumentComment>
                                  <CustomerFamily>
                                    <GdrpConsent>
                                      <LabelText>
                                        <DataCollectSection>
                                          <ArticleCharacteristics>
                                            <ArticleVariante>
                                              <ArticleUniver>
                                                <ArticleSubFamily>
                                                  <ArticleClassification2>
                                                    <ArticleClassification3>
                                                      <ArticleClassification1>
                                                        <ClientCountry>
                                                          <ClientCurrency>
                                                            <BankAccount>
                                                              <ArticleFamily>
                                                                <CustomerProvenance>
                                                                  <Identity>
                                                                    <ArticleMark>
                                                                      <PostalCode>
                                                                        <StockOutType>
                                                                          <Ticket>
                                                                            <Notification>
                                                                              <LicenceRequest>
                                                                                <Role>
                                                                                  <UserEntity>
                                                                                    <License>
                                                                                      <Tier>
                                                                                        <Devise>
                                                                                          <Pays>
                                                                                            <Domain>
                                                                                              <Mark>
                                                                                                <Tarif>{props.children}</Tarif>
                                                                                              </Mark>
                                                                                            </Domain>
                                                                                          </Pays>
                                                                                        </Devise>
                                                                                      </Tier>
                                                                                    </License>
                                                                                  </UserEntity>
                                                                                </Role>
                                                                              </LicenceRequest>
                                                                            </Notification>
                                                                          </Ticket>
                                                                        </StockOutType>
                                                                      </PostalCode>
                                                                    </ArticleMark>
                                                                  </Identity>
                                                                </CustomerProvenance>
                                                              </ArticleFamily>
                                                            </BankAccount>
                                                          </ClientCurrency>
                                                        </ClientCountry>
                                                      </ArticleClassification1>
                                                    </ArticleClassification3>
                                                  </ArticleClassification2>
                                                </ArticleSubFamily>
                                              </ArticleUniver>
                                            </ArticleVariante>
                                          </ArticleCharacteristics>
                                        </DataCollectSection>
                                      </LabelText>
                                    </GdrpConsent>
                                  </CustomerFamily>
                                </DocumentComment>
                              </PaymentDeadline>
                            </SupplierFamily>
                          </DeliveryZone>
                        </PaymentMethod>
                      </Taxe>
                    </VatProfile>
                  </BudgetLine>
                </LoyaltyProfile>
              </Supplier>
            </AccountingProfile>
          </Dossier>
        </Customer>
      </GlobalBudget>
    </AdvertisingOperation>
  );
}

export default FilterSortPaginationContextComponent;
